import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AffiliateFormComponent } from '../../components/affiliate-form/affiliate-form.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { HistoryListComponent } from '@shared/components/history-list/history-list.component';
import { Permission } from '@shared/enums/permission.enum';
import { PermissionService } from '@core/services/permission.service';
import { AffiliateStore } from '../../affiliate.store';
import { LookupStore } from '@core/lookup/lookup.store';
import { AFFILIATE_LOOKUP_CODES } from '@core/lookup/lookup-codes';
import { CreateAffiliateRequest } from '../../affiliate.model';
import { SHARED_IMPORTS } from '../../../../shared/modules/shared-imports.module';

@Component({
  selector: 'app-affiliate-detail-page',
  imports: [RouterLink, AffiliateFormComponent, HistoryListComponent, ...SharedMaterialUIModule, ...SHARED_IMPORTS],
  templateUrl: './affiliate-detail.page.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class AffiliateDetailPage {
  private readonly route = inject(ActivatedRoute);
  private readonly permissionService = inject(PermissionService);
  protected readonly affiliateStore = inject(AffiliateStore);
  protected readonly lookupStore = inject(LookupStore);

  protected readonly affiliateId = this.route.snapshot.paramMap.get('affiliateId') ?? '';

  constructor() {
    this.lookupStore.load(AFFILIATE_LOOKUP_CODES);

    if (this.affiliateId) {
      this.affiliateStore.loadAffiliate(this.affiliateId);
      this.affiliateStore.loadAffiliateHistory(this.affiliateId);
    }
  }

  protected canUpdate(): boolean {
    return this.permissionService.hasPermission(Permission.AffiliatesUpdate);
  }

  protected saveAffiliate(request: CreateAffiliateRequest): void {
    if (!this.affiliateId || !this.canUpdate()) {
      return;
    }

    this.affiliateStore.updateAffiliate(this.affiliateId, request, () => {
      this.affiliateStore.loadAffiliate(this.affiliateId);
    });
  }
}
